"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-felice-del-benaco": {
    "46e54a1d": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "skipSearch": false
    }],
    "cremezzano": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1f81e78": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "skipSearch": false
    }],
    "oriano": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4640c5a7": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "skipSearch": false
    }],
    "pedergnaga": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0927d71f": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "skipSearch": false
    }],
    "scarpizzolo": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7bfe6c0d": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "skipSearch": false
    }],
    "trignano": [{
      "hkey": "5e28cbb2",
      "slug": "san-felice-del-benaco",
      "name": "San Felice del Benaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;